export default __webpack_public_path__ + "static/media/Roxana Monetti.5d75015f.jpg";